import moment from "moment";
import * as XLSX from "xlsx-js-style";

/**
 * Export Time Off data to Excel
 * @param {Array} data
 * @param {Number} selectedYear
 * @param {String} selectedExcel
 */
export const exportToExcel = (data, selectedYear, selectedExcel = "access") => {

    let filePrefix = "Time_Off_Data";

    if (selectedExcel === "change") {
        filePrefix = "Change_Time_Off_Data";
    }

    const fileName =
        `${filePrefix}_${selectedYear}_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;


    // Filter by year
    const filteredData = data.filter(item =>
        moment(item.created_at).year() === selectedYear
    );

    /*
    ======================
    HEADER ACCESS
    ======================
    */
    let headers = [
        "No",
        "User Code",
        "Name",
        "Default Time Off",
        "Bonus Time Off",
        "Used Time Off",
        "Cut Time Off",
        "Remainder Time Off",
        "Status",
    ];

    /*
    ======================
    HEADER CHANGE
    ======================
    */
    if (selectedExcel === "change") {

        headers = [
            "No",
            "User Code",
            "Name",
            "Bonus Time Off",
            "Bonus Start Date",
            "Bonus End Date",
            "Cut Time Off",
            "Cut Start Date",
            "Cut End Date",
            "Notes",
            "Status",
        ];
    }

    /*
    ======================
    DATA ACCESS
    ======================
    */
    let dataBody = filteredData.map((record, index) => [

        index + 1,
        record.users_code || '',
        record.name || '',
        record.leave_paid_default ?? 0,
        record.leave_obtained ?? 0,
        record.leave_used ?? 0,
        record.cut_leave ?? 0,
        record.total_leave_end ?? 0,
        "Active",
    ]);


    /*
    ======================
    DATA CHANGE
    ======================
    */
    if (selectedExcel === "change") {

        const startYear = moment(`${selectedYear}-01-01`).format("M/D/YYYY");
        const endYear = moment(`${selectedYear}-12-31`).format("M/D/YYYY");

        dataBody = filteredData.map((record, index) => [
            index + 1,
            record.users_code || '',
            record.name || '',
            0,
            startYear,
            endYear,
            0,
            '',
            '',
            '',
            "Aktif",
        ]);
    }

    /*
    ======================
    TITLE
    ======================
    */

    let titleText = "Time Off Employee Data";

    if (selectedExcel === "change") {
        titleText = "Change Bonus / Cut Leave Paid";
    }

    const titleRow = [[{
        v: titleText,
        s: {
            font: { bold: true, sz: 16 },
            alignment: { horizontal: "center" }
        }
    }]];

    const yearRow = [[{
        v: `Year: ${selectedYear}`,
        s: {
            font: { italic: true },
            alignment: { horizontal: "center" }
        }
    }]];

    /*
    ======================
    STYLE HEADER
    ======================
    */

    const styledHeaders = headers.map(h => ({
        v: h,
        s: {
            font: { bold: true },
            fill: { fgColor: { rgb: "D9E1F2" } },
            border: {
                top: { style: "thin" },
                bottom: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" },
            },
            alignment: { horizontal: "center" }
        }
    }));

    /*
    ======================
    STYLE DATA
    ======================
    */

    const styledDataBody = dataBody.map(row =>
        row.map(cell => ({
            v: cell,
            s: {
                border: {
                    top: { style: "thin" },
                    bottom: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" },
                },
                alignment: { horizontal: "center" }
            }
        }))
    );

    /*
    ======================
    BUILD SHEET
    ======================
    */

    const worksheetData = [
        ...titleRow,
        ...yearRow,
        styledHeaders,
        ...styledDataBody
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    worksheet["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } },
    ];

    worksheet["!cols"] = headers.map(header => ({
        wch: Math.max(header.length + 3, 18)
    }));

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "TimeOff");

    XLSX.writeFile(workbook, fileName);
};